<template>
    <div>
        <site-header />
        <div class="study-course">

            <div class="course-header">
                <div class="course-cover">
                    <img :src="courseDetail.imageUrl" :alt="courseDetail.name">
                </div>
                <div class="course-info">
                    <h1 class="course-title">{{ courseDetail.name }}</h1>
                    <div class="course-meta">
                        <div class="meta-group">
                            <span class="meta-item">
                                <i class="el-icon-time"></i>
                                <span class="meta-label">课时时111长</span>
                                <span class="meta-value">{{ courseDetail.coursePeriod }}分钟</span>
                            </span>
                            <span class="meta-item">
                                <i class="el-icon-medal"></i>
                                <span class="meta-label">课程学分</span>
                                <span class="meta-value">{{ courseDetail.courseCredit }}</span>
                            </span>
                        </div>
                        <div class="meta-group">
                            <span class="meta-item">
                                <i class="el-icon-date"></i>
                                <span class="meta-label">有效期</span>
                                <span class="meta-value">{{ courseDetail.validityText }}</span>
                            </span>
                            <span class="meta-item">
                                <i class="el-icon-user"></i>
                                <span class="meta-label">学习人数</span>
                                <span class="meta-value">{{ courseDetail.courseHot || 0 }}</span>
                            </span>
                        </div>
                    </div>
                    <div class="course-desc">{{ courseDetail.courseDesc || '该课程暂无介绍' }}</div>
                </div>
            </div>

            <div class="progress-box" v-if="Number(courseDetail.courseType) === 2">
                <div class="progress-card">
                    <div class="progress-title">学习进度</div>
                    <el-progress :percentage="totalProgress" :stroke-width="10"
                        :color="'#a0a6ff'" :show-text="true" />
                    <div class="progress-text">
                        <span v-if="totalProgress < 90" style="color:#E6A23C;font-size:13px;">学习进度达到百分之九十后才可以进行刷题或考试</span>
                        <span v-else style="color:#67C23A;font-size:13px;">学习进度已达到要求</span>
                    </div>
                </div>
            </div>

            <div class="course-content">
                <el-tabs v-model="activeTab" class="course-tabs">
                    <el-tab-pane label="课程目录" name="catalog">
                        <div class="catalog-list">
                            <!-- 学时学习 -->
                            <div class="catalog-section" v-for="(section, index) in filteredLayout" :key="index">
                                <div class="section-header">
                                    <span class="section-title">{{ section.name }}</span>
                                </div>
                                <div class="section-content">
                                    <div class="catalog-item" v-for="(item, itemIndex) in section.children"
                                        :key="itemIndex" @click="handleStudyItem(item)">
                                        <i :class="getItemIcon(item.type)"></i>
                                        <span class="item-title">{{ item.name }}</span>
                                        <span class="item-status">{{ getItemStatus(item.type) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane v-if="courseDetail.majorId != 47" label="课程资源" name="resource">
                        <div class="course-resource-content">
                            <template v-if="resourceList.length === 0 && !resourceLoading">
                                <el-empty description="暂无课程资源">
                                    <el-button type="primary" @click="openConfigDialog">去配置</el-button>
                                </el-empty>
                            </template>
                            <template v-else>
                                <el-table :data="resourceList" v-loading="resourceLoading"
                                    style="width: 100%; cursor: pointer" border @row-click="handleResourceRowClick">
                                    <el-table-column prop="imageUrl" label="封面" width="100">
                                        <template slot-scope="scope">
                                            <img :src="scope.row.imageUrl" :alt="scope.row.name"
                                                style="width:80px;height:60px;object-fit:cover;" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="name" label="资源名称" min-width="180" />
                                    <el-table-column prop="duration" label="时长(分钟)" width="100" />
                                    <el-table-column prop="fileType" label="类型" width="80">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.fileType == '1'">图片</span>
                                            <span v-else>视频</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="rate" label="学习进度" width="120">
                                        <template slot-scope="scope">
                                            <el-progress :percentage="Number(scope.row.rate) || 0" :text-inside="true"
                                                :stroke-width="18" status="success" />
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div style="margin: 20px 0; text-align: right;">
                                    <el-pagination background layout="prev, pager, next, jumper"
                                        :current-page="resourcePageNum" :page-size="resourcePageSize"
                                        :total="resourceTotal" @current-change="handleResourcePageChange" />
                                </div>
                            </template>
                        </div>
                        <el-dialog title="可配置资源" :visible.sync="configDialogVisible" width="80%"
                            @close="closeConfigDialog">
                            <div class="config-dialog-header">
                                <div class="config-course-title">{{ courseDetail.name }}</div>
                                <div class="config-course-range">
                                    课程时长区间：{{ minMinutes }} ~ {{ maxMinutes }} 分钟
                                </div>
                                <div class="config-course-selected">
                                    已选时长：<span
                                        :class="{ 'over-range': selectedResourceDuration < minMinutes || selectedResourceDuration > maxMinutes }">{{
                                            selectedResourceDuration }}</span> 分钟
                                </div>
                            </div>
                            <div class="all-resource-scroll-list" v-loading="allResourceLoading"
                                @scroll="handleAllResourceScroll" ref="allResourceScroll">
                                <el-row :gutter="20">
                                    <el-col :span="6" v-for="item in allResourceList" :key="item.materialId">
                                        <div class="resource-card-wrapper" @click="handleSelectResource(item)"
                                            :class="{ 'is-selected': isResourceSelected(item.materialId) }">
                                            <el-card class="resource-card" shadow="hover">
                                                <img :src="item.imageUrl" :alt="item.name" />
                                                <div class="resource-card-content">
                                                    <div class="resource-card-title">{{ item.name }}</div>
                                                    <div class="resource-card-meta">类型：<span
                                                            v-if="item.fileType == '1'">图片</span><span v-else>文档</span>
                                                    </div>
                                                    <div class="resource-card-meta">时长：{{ item.duration }}分钟</div>
                                                    <div class="resource-card-meta">价格：{{ item.price }}</div>
                                                </div>
                                                <div class="resource-card-checkbox" @click.stop>
                                                    <el-checkbox :checked="isResourceSelected(item.materialId)" />
                                                </div>
                                            </el-card>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="config-dialog-footer">
                                <el-button type="primary" :disabled="!canConfirm()"
                                    @click="handleSaveResource">确定</el-button>
                            </div>
                        </el-dialog>
                    </el-tab-pane>
                    <el-tab-pane label="课程详情" name="detail">
                        <div class="course-detail-content">
                            <template v-if="courseDetail.courseDesc && courseDetail.courseDesc.trim()">
                                <div v-html="courseDetail.courseDesc"></div>
                            </template>
                            <template v-else>
                                该课程暂无介绍
                            </template>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>

            <!-- 统一的资源预览弹窗 -->
            <el-drawer title="资源预览" :visible.sync="previewDialogVisible" size="60%" :with-header="true"
                :close-on-click-modal="false" :close-on-press-escape="true" @close="handlePreviewDialogClose">
                <div class="drawer-content">
                    <div v-if="currentResourceRow">
                        <!-- <div style="color:#888;font-size:12px;margin-bottom:8px;">
                            fileType: {{ currentResourceRow.fileType }}<br>
                            originalUrl: {{ currentResourceRow.originalUrl }}
                        </div> -->
                        <video v-if="currentResourceRow.fileType == '2' && currentResourceRow.originalUrl"
                            ref="videoPlayer" class="video-player" controls :src="currentResourceRow.originalUrl"
                            style="width: 80%; height: 60vh; margin: 24px auto; border-radius: 12px; box-shadow: 0 2px 12px #0001; display: block;">
                            您的浏览器不支持 video 标签
                        </video>
                        <img v-else-if="currentResourceRow.fileType == '1' && (currentResourceRow.originalUrl || currentResourceRow.imageUrl)"
                            :src="currentResourceRow.originalUrl || currentResourceRow.imageUrl" alt="图片预览"
                            style="max-width: 100%; max-height: 60vh; margin: 24px auto; display: block; border-radius: 12px; box-shadow: 0 2px 12px #0001;" />
                        <div v-else style="text-align: center; padding: 40px;">
                            <p>无法识别的资源类型，暂不支持预览。</p>
                            <p>当前资源ID: {{ currentResourceRow && currentResourceRow.materialId }}</p>
                        </div>
                    </div>
                </div>
            </el-drawer>

            <!-- 档案资料弹窗 -->
            <el-drawer title="档案资料" :visible.sync="archiveDialogVisible" size="60%" :with-header="true"
                :close-on-click-modal="false" :close-on-press-escape="true">
                <div class="drawer-content">
                    <el-row :gutter="20">
                        <el-col :span="8" v-for="(item, index) in archiveList" :key="index">
                            <el-card class="archive-item-card" shadow="hover" style="margin-bottom: 20px;">
                                <div class="archive-image">
                                    <img :src="item.imageUrl" :alt="item.name"
                                        style="width:100%;height:160px;object-fit:cover;border-radius:8px;box-shadow:0 2px 8px #0001;" />
                                </div>
                                <div class="archive-info" style="margin-top:12px;">
                                    <h3 style="margin:0 0 8px 0;">{{ item.name }}</h3>
                                    <div class="archive-meta" style="color:#888;">
                                        <span class="meta-item"><i class="el-icon-time"></i> {{ item.duration
                                        }}分钟</span>
                                        <span class="meta-item"><i class="el-icon-document"></i> {{ item.fileType ===
                                            '1' ?
                                            '图片' :
                                            '文档' }}</span>
                                    </div>
                                    <el-button type="primary" size="mini" style="margin-top:10px;"
                                        @click="handleArchiveItemClick(item)">查看</el-button>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </div>
            </el-drawer>

            <!-- 视频列表弹窗 -->
            <el-drawer title="视频列表" :visible.sync="videoListDialogVisible" size="60%" :with-header="true"
                :close-on-click-modal="false" :close-on-press-escape="true">
                <div class="drawer-content">
                    <el-card v-for="(section, index) in videoList" :key="index" class="chapter-section" shadow="hover"
                        style="margin-bottom: 20px;">
                        <div class="section-header"
                            style="display:flex;justify-content:space-between;align-items:center;">
                            <h3 style="margin:0;">{{ section.name }}</h3>
                        </div>
                        <div class="section-content" style="margin-top:12px;">
                            <el-row :gutter="16">
                                <el-col :span="12" v-for="(item, itemIndex) in section.materials" :key="itemIndex">
                                    <el-card class="video-item-card" shadow="never" style="margin-bottom: 12px;">
                                        <div style="display:flex;align-items:center;gap:16px;">
                                            <img :src="item.imageUrl" :alt="item.name"
                                                style="width:100px;height:70px;object-fit:cover;border-radius:8px;box-shadow:0 2px 8px #0001;" />
                                            <div style="flex:1;">
                                                <h4 style="margin:0 0 6px 0;">{{ item.name }}</h4>
                                                <div style="color:#999;">{{ item.remarks || '暂无描述' }}</div>
                                                <div style="color:#409EFF;margin-top:4px;">时长：{{ item.duration }}分钟
                                                </div>
                                                <el-button type="primary" size="mini" style="margin-top:6px;"
                                                    @click="playVideo(item)">播放</el-button>
                                            </div>
                                        </div>
                                    </el-card>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                </div>
            </el-drawer>

            <!-- 章节练习弹窗 -->
            <el-drawer title="章节练习" :visible.sync="chapterTreeDialogVisible" size="60%" :with-header="true"
                :close-on-click-modal="false" :close-on-press-escape="true">
                <div class="drawer-content">
                    <el-card v-for="(section, index) in chapterTree" :key="index" class="chapter-section" shadow="hover"
                        style="margin-bottom: 20px;">
                        <div class="section-header"
                            style="display:flex;justify-content:space-between;align-items:center;">
                            <h3 style="margin:0;">{{ section.name }}</h3>
                            <span style="color:#409EFF;">题目数量：{{ section.questionCount || 0 }}</span>
                        </div>
                        <div class="section-content" style="margin-top:12px;">
                            <el-row :gutter="16">
                                <el-col :span="12" v-for="(item, itemIndex) in section.children" :key="itemIndex">
                                    <el-card class="chapter-item" shadow="never" style="margin-bottom: 12px;">
                                        <div style="display:flex;justify-content:space-between;align-items:center;">
                                            <div>
                                                <h4 style="margin:0 0 6px 0;">{{ item.name }}</h4>
                                                <div style="color:#999;">题目数量：{{ item.questionCount || 0 }}</div>
                                            </div>
                                            <el-button type="primary" size="small"
                                                @click="startPractice(item)">开始练习</el-button>
                                        </div>
                                    </el-card>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                </div>
            </el-drawer>

            <!-- 新增：考试详情弹窗 -->
            <el-drawer title="结业考试" :visible.sync="examDrawerVisible" size="60%" :with-header="true"
                :close-on-click-modal="false" :close-on-press-escape="true">
                <div class="drawer-content">
                    <el-card v-if="currentExamDetail" class="chapter-section" shadow="hover"
                        style="margin-bottom: 20px;">
                        <div class="section-header"
                            style="display:flex;justify-content:space-between;align-items:center;">
                            <h3 style="margin:0;">{{ currentExamDetail.questionBankName }}</h3>
                            <span style="color:#409EFF;">总分：{{ currentExamDetail.totalScore }}，及格分：{{
                                currentExamDetail.passScore
                            }}</span>
                        </div>
                        <div class="section-content" style="margin-top:12px;">
                            <el-table :data="currentExamDetail.questionConfigs" border style="width: 100%;">
                                <el-table-column prop="type" label="题型" width="100">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.type == 1">单选题</span>
                                        <span v-else-if="scope.row.type == 2">多选题</span>
                                        <span v-else-if="scope.row.type == 3">判断题</span>
                                        <span v-else>其他</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="questionsNumber" label="题目数量" width="100" />
                                <el-table-column prop="questionsScore" label="每题分值" width="100" />
                            </el-table>
                        </div>
                        <div style="text-align:right;margin-top:24px;">
                            <el-button type="primary" @click="startExam" :disabled="!canStartExam">开始考试</el-button>
                        </div>
                    </el-card>
                </div>
            </el-drawer>


        </div>
        <site-footer />
    </div>
</template>

<script>
import { getCourseResource, getChapterTree, getMaterialLists, getAllMaterialList, saveCourseResource, addTrainLearnRecord, bizTypeExamination, QuestionsConfig, checkIsYearEndOver, getTotalDurationBySignup } from '@/api/course'
import { getLearnProgress } from '@/api/course'
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
export default {
    name: 'StudyCourse',
    components: {
        SiteHeader,
        SiteFooter
    },
    data() {
        return {
            activeTab: 'catalog',
            courseDetail: {},
            courseLayout: [],
            videoDialogVisible: false,
            currentVideoUrl: '',
            currentItem: null,
            archiveDialogVisible: false,
            archiveList: [],
            videoListDialogVisible: false,
            videoList: [],
            chapterTreeDialogVisible: false,
            chapterTree: [],
            resourceList: [],
            resourceTotal: 0,
            resourcePageNum: 1,
            resourcePageSize: 10,
            resourceLoading: false,
            configDialogVisible: false,
            allResourceList: [],
            allResourceLoading: false,
            allResourcePageNum: 1,
            allResourcePageSize: 20,
            allResourceTotal: 0,
            allResourceFinished: false,
            selectedResourceIds: [],
            selectedResourceDuration: 0,
            imageOpenTime: 0,
            currentResourceRow: null,
            previewDialogVisible: false,
            currentPdfPage: 1,
            videoStartTime: 0,
            examList: [],
            examDrawerVisible: false,
            currentExamDetail: null,
            learnProgress: 0,
            totalProgress: 0,
        }
    },
    computed: {
        filteredLayout() {
            return this.courseLayout
                .filter(section => section.add === true || section.add === 'true')
                .map(section => ({
                    ...section,
                    children: (section.children || []).filter(
                        item => item.add === true || item.add === 'true'
                    )
                }))
                .filter(section => section.children.length > 0)
        },
        minMinutes() {
            // 优先使用 courseValidityKey 的区间逻辑（跟另一套 CourseDetail 一致）
            const courseTimeEnum = { 4: 20, 5: 40, 6: 60 }
            const validityKey = Number(this.courseDetail.courseValidityKey || this.courseDetail.validityKey || 0)
            if (courseTimeEnum[validityKey]) {
                const min = courseTimeEnum[validityKey] * 38
                return Number.isFinite(min) ? min : 0
            }

            // 回退：没有 validityKey 时沿用原来的 +/-40 逻辑，避免影响现有页面
            const period = Number(this.courseDetail.coursePeriod) || 0
            return period > 0 ? period - 40 : 0
        },
        maxMinutes() {
            // 优先使用 courseValidityKey 的区间逻辑（跟另一套 CourseDetail 一致）
            const courseTimeEnum = { 4: 20, 5: 40, 6: 60 }
            const validityKey = Number(this.courseDetail.courseValidityKey || this.courseDetail.validityKey || 0)
            if (courseTimeEnum[validityKey]) {
                const max = courseTimeEnum[validityKey] * 42
                return Number.isFinite(max) ? max : 0
            }

            // 回退：没有 validityKey 时沿用原来的 +/-40 逻辑，避免影响现有页面
            const period = Number(this.courseDetail.coursePeriod) || 0
            return period > 0 ? period + 40 : 0
        },
        canStartExam() {
            return this.learnProgress >= 90
        }
    },
    created() {
        // 在页面创建时添加body类名以隐藏广告
        document.body.classList.add('no-side-ad-study-course');
        
        // 先检查课程是否过期
        let courseId = '';
        // 兼容不同来源的courseId
        if (this.$route.query && this.$route.query.courseId) {
            courseId = this.$route.query.courseId;
        } else if (this.$route.query && this.$route.query.majorData) {
            try {
                const majorData = JSON.parse(decodeURIComponent(this.$route.query.majorData));
                if (majorData.courseDetail && majorData.courseDetail.courseId) {
                    courseId = majorData.courseDetail.courseId;
                }
            } catch (e) { /* 忽略JSON解析错误 */ }
        }
        if (courseId) {
            checkIsYearEndOver({ courseId }).then(res => {
                if (res.code === 500) {
                    this.$message.error(res.msg || '该课程已经过期，请重新购买');
                    this.$router.replace({ name: 'ArchiveCourse' });
                } else {
                    this.initCourseData();
                }
            }).catch(() => {
                this.initCourseData();
            });
        } else {
            this.initCourseData();
        }
    },
    beforeDestroy() {
        // 在组件销毁时移除body类名，恢复广告显示
        document.body.classList.remove('no-side-ad-study-course');
    },
    methods: {
        initCourseData() {
            try {
                console.log('Raw majorData:', this.$route.query.majorData)
                const majorData = JSON.parse(decodeURIComponent(this.$route.query.majorData || '{}'))
                console.log('Parsed majorData:', majorData)
                console.log('Layout type:', typeof majorData.layout)
                console.log('Layout value:', majorData.layout)

                this.courseDetail = majorData.courseDetail || {}

                // 解析 layout 字符串为 JSON 对象
                if (typeof majorData.layout === 'string') {
                    try {
                        this.courseLayout = JSON.parse(majorData.layout)
                        console.log('Parsed layout:', this.courseLayout)
                    } catch (e) { /* 忽略JSON解析错误 */ }
                } else if (Array.isArray(majorData.layout)) {
                    this.courseLayout = majorData.layout
                    console.log('Using array layout:', this.courseLayout)
                } else {
                    console.warn('Layout is neither string nor array:', majorData.layout)
                    this.courseLayout = []
                }

                console.log('Final course data:', {
                    courseDetail: this.courseDetail,
                    courseLayout: this.courseLayout
                })
                // 解析完 courseDetail 后查进度
                this.fetchLearnProgress()
                this.fetchTotalProgress()
            } catch (error) {
                console.error('解析课程数据失败:', error)
                this.$message.error('获取课程数据失败')
            }
        },
        async fetchLearnProgress() {
            if (!this.courseDetail.courseId || !this.courseDetail.majorId) return
            try {
                const res = await getLearnProgress({
                    courseId: this.courseDetail.courseId,
                    majorId: this.courseDetail.majorId
                })
                if (res.code === 200 && res.data && res.data.learnProgress) {
                    this.learnProgress = parseFloat(res.data.learnProgress)
                } else {
                    this.learnProgress = 0
                }
            } catch {
                this.learnProgress = 0
            }
        },
        fetchTotalProgress() {
            const signupId = this.courseDetail.signupId
            const courseId = this.courseDetail.courseId
            const courseSecond = Number(this.courseDetail.coursePeriod) || 0
            if (!signupId || !courseId) return
            getTotalDurationBySignup(signupId, courseId).then(res => {
                if (res.code == 200) {
                    const learnedMinutes = res.data || 0
                    if (courseSecond > 0) {
                        this.totalProgress = Math.min(Math.floor((learnedMinutes / courseSecond) * 100), 100)
                    } else {
                        this.totalProgress = 0
                    }
                }
            }).catch(() => {})
        },
        playVideo(item) {
            this.currentResourceRow = item;
            this.previewDialogVisible = true;
        },
        async handleVideoEnded() {
            if (this.currentItem) {
                const video = this.$refs.videoPlayer
                const duration = Math.round(video.currentTime)
                const total = Math.round(video.duration)
                const min = Math.floor(duration / 60)
                const sec = duration % 60
                const progress = `${min}:${sec < 10 ? '0' : ''}${sec}`
                const nowRate = Math.round((duration / total) * 100)
                await this.uploadLearnRecord({
                    materialId: this.currentItem.materialId,
                    progress,
                    duration,
                    nowRate
                })
            }
            this.$message.success('本节课程学习完成')
        },
        async handleVideoDialogClose() {
            this.videoDialogVisible = false
            if (this.$refs.videoPlayer && this.currentItem) {
                const video = this.$refs.videoPlayer
                const duration = Math.round(video.currentTime)
                const total = Math.round(video.duration)
                const min = Math.floor(duration / 60)
                const sec = duration % 60
                const progress = `${min}:${sec < 10 ? '0' : ''}${sec}`
                const nowRate = Math.round((duration / total) * 100)
                await this.uploadLearnRecord({
                    materialId: this.currentItem.materialId,
                    progress,
                    duration,
                    nowRate
                })
            }
            if (this.$refs.videoPlayer) {
                this.$refs.videoPlayer.pause()
            }
        },
        handleStudyItem(item) {
            // 获取课程ID和专业ID
            const courseId = this.courseDetail.courseId
            const majorId = this.courseDetail.majorId

            const normalizedItemType = String(item.type)
            // 跟你那套 CourseDetail 一致：学时课程（courseType==2）且进度 < 90 时，只允许“视频录播相关”功能
            const courseType = Number(this.courseDetail.courseType)
            const studyProgressPercent = Number(this.learnProgress) || 0
            const allowedTypesForLowProgress = new Set(['18', '7']) // 只拦截关键功能，放行录播相关
            if (courseType === 2 && studyProgressPercent < 90 && !allowedTypesForLowProgress.has(normalizedItemType)) {
                this.$message.warning('学习进度达到90%后才能使用此功能')
                return
            }

            // 获取等级和方向，确保动态获取且包含1
            const level = this.ensureContainsOne(this.$route.query.courseLevel)
            const direction = this.ensureContainsOne(this.$route.query.courseDirection)

            // 获取章节ID，从当前点击的item中获取objId
            const chapterIds = item.objId || ''

            // 使用item中的type作为业务类型
            const bizType = item.type

            console.log('请求参数:', {
                bizType,
                majorId,
                level,
                direction,
                chapterIds,
                courseId
            })

            // 考试/练习类：跟你那套 CourseDetail 扩展为按 item.type 动态拉取试卷配置
            const examBizTypes = new Set(['2', '3', '4', '5', '14', '15', '16', '17', '20', '21'])
            if (examBizTypes.has(normalizedItemType)) {
                const province = this.$route.query.province || ''
                const params = {
                    majorId: this.courseDetail.majorId,
                    level,
                    province,
                    quizType: normalizedItemType,
                    direction
                }
                QuestionsConfig(params)
                    .then(res => {
                        if (res.code === 200 && res.data && res.data.length > 0) {
                            this.currentExamDetail = res.data[0]
                            this.examDrawerVisible = true
                        } else {
                            this.$message.info('暂无可用试卷')
                        }
                    })
                    .catch(() => {
                        this.$message.error('获取试卷列表失败')
                    })
                return
            }

            getCourseResource({
                bizType,
                majorId,
                level,
                direction,
                chapterIds,
                courseId
            }).then(res => {
                if (res.code === 200) {
                    // 根据不同类型处理返回数据
                    switch (normalizedItemType) {
                        case '11': // 档案资料
                            if (res.rows && res.rows.length > 0 && res.rows[0].materials && res.rows[0].materials.length > 0) {
                                this.archiveList = res.rows[0].materials
                                this.archiveDialogVisible = true
                            } else {
                                this.$message.info('暂无档案资料')
                            }
                            break
                        case '7':
                        case '8':
                        case '9':
                        case '10':
                        case '18':
                        case '19': // 视频学习/录播相关
                            if (res.rows && res.rows.length > 0 && res.rows[0].children && res.rows[0].children.length > 0) {
                                // 你的接口返回层级大概是：type=1 -> children(type=2) -> children(type=3) -> materials(视频)
                                // 当前弹窗模板要求：videoList = [{ name, materials: [...] }, ...]
                                const sections = []
                                const walk = (node) => {
                                    if (!node) return
                                    // 取真正的“视频节”(type=3)，把 materials 挂到 section.materials
                                    if (String(node.type) === '3') {
                                        sections.push({
                                            ...node,
                                            materials: node.materials || []
                                        })
                                    }
                                    if (node.children && node.children.length > 0) {
                                        node.children.forEach(walk)
                                    }
                                }
                                ;(res.rows || []).forEach(r => {
                                    if (r && r.children && r.children.length > 0) {
                                        r.children.forEach(walk)
                                    } else {
                                        walk(r)
                                    }
                                })

                                this.videoList = sections
                                this.videoListDialogVisible = true
                            } else {
                                this.$message.info('暂无视频内容')
                            }
                            break
                        case '0':
                        case '1': // 章节练习树
                            // 获取章节树数据
                            getChapterTree({
                                majorId,
                                direction,
                                level,
                                chapterIds
                            }).then(res => {
                                if (res.code === 200 && res.data && res.data.length > 0) {
                                    this.chapterTree = res.data
                                    this.chapterTreeDialogVisible = true
                                } else {
                                    this.$message.info('暂无章节练习')
                                }
                            }).catch(error => {
                                console.error('获取章节树失败:', error)
                                this.$message.error('获取章节练习失败')
                            })
                            break
                       
                    }
                } else {
                    this.$message.error(res.msg || '获取资源失败')
                }
            }).catch(error => {
                console.error('获取资源失败:', error)
                this.$message.error('获取资源失败')
            })
        },
        getItemIcon(type) {
            switch (type) {
                case 'archive':
                    return 'el-icon-document'
                case 'video':
                    return 'el-icon-video-play'
                case 'review':
                    return 'el-icon-notebook-2'
                default:
                    return 'el-icon-document'
            }
        },
        getItemStatus(type) {
            switch (type) {
                case 'archive':
                    return '查看资料'
                case 'video':
                    return '开始学习'
                case 'review':
                    return '开始复习'
                default:
                    return '查看资料'
            }
        },
        handleArchiveDialogClose() {
            this.archiveDialogVisible = false
            this.archiveList = []
        },
        handleArchiveItemClick(item) {
            console.log('点击了查看', item);
            if (item.fileType === '1') {
                window.open(item.originalUrl || item.imageUrl);
            } else if (item.fileType === '2') {
                console.log('currentResourceRow:', item);
                this.currentResourceRow = item;
                this.previewDialogVisible = true;
                console.log('previewDialogVisible:', this.previewDialogVisible);
            } else {
                this.$message.info('暂不支持该类型预览');
            }
        },
        handleVideoListDialogClose() {
            this.videoListDialogVisible = false
            this.videoList = []
        },
        handleChapterTreeDialogClose() {
            this.chapterTreeDialogVisible = false
            this.chapterTree = []
        },
        async startPractice(item) {
            // 显示全局 loading
            const loading = this.$loading({
                lock: true,
                text: '正在加载题目，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            // 动态获取 bizType，章节练习传 1
            const params = {
                majorId: this.courseDetail.majorId,
                bizType: item.bizType || '1'
            }
            // 章节练习才传 chapterId
            if (item.objId || item.id) {
                params.chapterId = item.objId || item.id
            }
            // 有 quizConfigId 就带上
            if (item.quizConfigId) {
                params.quizConfigId = item.quizConfigId
            }

            try {
                const res = await bizTypeExamination(params)
                if (res.code === 200 && res.data && res.data.trainQuestionList) {
                    // 跳转到练习页面，带上题目数据
                    this.$router.push({
                        name: 'PracticePage',
                        query: {
                            majorId: params.majorId,
                            bizType: params.bizType,
                            chapterId: params.chapterId,
                            quizConfigId: params.quizConfigId
                        }
                    })
                    // 题目数据存 localStorage
                    localStorage.setItem('trainQuestionList', JSON.stringify(res.data.trainQuestionList))
                } else {
                    this.$message.error(res.msg || '获取题目失败')
                }
            } catch (e) {
                this.$message.error('获取题目失败')
            } finally {
                // 关闭 loading
                loading.close();
            }
        },
        async fetchResourceList(pageNum) {
            this.resourceLoading = true
            const courseId = this.courseDetail.courseId
            const majorId = this.courseDetail.majorId
            const pageSize = this.resourcePageSize
            const params = {
                courseId,
                majorId,
                pageNum: pageNum || this.resourcePageNum,
                pageSize
            }
            try {
                const res = await getMaterialLists(params)
                if (res.code === 200) {
                    this.resourceList = (res.rows || []).map(item => {
                        let rate = Number(item.rate) || 0;
                        if ((!rate || rate === 0) && item.learnRecordDTO && item.learnRecordDTO.nowRate) {
                            rate = Number(item.learnRecordDTO.nowRate) * 100;
                        }
                        return {
                            ...item,
                            rate
                        }
                    });
                    this.resourceTotal = res.total || 0
                    this.resourcePageNum = params.pageNum
                } else {
                    this.$message.error(res.msg || '获取课程资源失败')
                }
            } catch (e) {
                this.$message.error('获取课程资源失败')
            } finally {
                this.resourceLoading = false
            }
        },
        handleResourcePageChange(page) {
            this.fetchResourceList(page)
        },
        async fetchAllResourceList() {
            if (this.allResourceLoading || this.allResourceFinished) return
            this.allResourceLoading = true
            const majorId = this.courseDetail.majorId
            const params = {
                majorId,
                pageNum: this.allResourcePageNum,
                pageSize: this.allResourcePageSize
            }
            try {
                const res = await getAllMaterialList(params)
                if (res.code === 200) {
                    const rows = res.rows || []
                    this.allResourceList = this.allResourceList.concat(rows)
                    this.allResourceTotal = res.total || 0
                    if (this.allResourceList.length >= this.allResourceTotal) {
                        this.allResourceFinished = true
                    } else {
                        this.allResourcePageNum += 1
                    }
                } else {
                    this.$message.error(res.msg || '获取全部资源失败')
                }
            } catch (e) {
                this.$message.error('获取全部资源失败')
            } finally {
                this.allResourceLoading = false
            }
        },
        openConfigDialog() {
            this.configDialogVisible = true
            this.allResourceList = []
            this.allResourcePageNum = 1
            this.allResourceTotal = 0
            this.allResourceFinished = false
            this.selectedResourceIds = []
            this.selectedResourceDuration = 0
            this.fetchAllResourceList()
        },
        closeConfigDialog() {
            this.configDialogVisible = false
        },
        handleAllResourceScroll(e) {
            const el = e.target
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
                this.fetchAllResourceList()
            }
        },
        handleSelectResource(item) {
            const idx = this.selectedResourceIds.indexOf(item.materialId)
            if (idx > -1) {
                // 已选中，取消选中
                this.selectedResourceIds.splice(idx, 1)
            } else {
                // 新选中，先判断是否超时长
                const tempIds = this.selectedResourceIds.concat(item.materialId)
                const tempDuration = this.allResourceList
                    .filter(item => tempIds.includes(item.materialId))
                    .reduce((sum, item) => sum + (Number(item.duration) || 0), 0)
                if (tempDuration > this.maxMinutes) {
                    this.$message.warning('已超出最大可选时长，请重新选择')
                    return
                }
                this.selectedResourceIds.push(item.materialId)
            }
            this.updateSelectedDuration()
        },
        updateSelectedDuration() {
            this.selectedResourceDuration = this.allResourceList
                .filter(item => this.selectedResourceIds.includes(item.materialId))
                .reduce((sum, item) => sum + (Number(item.duration) || 0), 0)
        },
        isResourceSelected(id) {
            return this.selectedResourceIds.includes(id)
        },
        canConfirm() {
            return (
                this.selectedResourceDuration >= this.minMinutes &&
                this.selectedResourceDuration <= this.maxMinutes &&
                this.selectedResourceIds.length > 0
            )
        },
        async handleSaveResource() {
            if (!this.canConfirm()) {
                this.$message.warning('请选择合适时长的资源')
                return
            }
            const params = {
                courseId: this.courseDetail.courseId,
                resouceId: this.selectedResourceIds.join(',')
            }
            try {
                const res = await saveCourseResource(params)
                if (res.code === 200) {
                    this.$message.success('保存成功')
                    this.configDialogVisible = false
                    this.fetchResourceList(1)
                } else {
                    this.$message.error(res.msg || '保存失败')
                }
            } catch (e) {
                this.$message.error('保存失败')
            }
        },
        async handleResourceRowClick(row) {
            console.log('点击资源行，类型:', row.fileType, '数据:', row);
            this.currentResourceRow = row;

            // 统一打开预览弹窗
            this.previewDialogVisible = true;

            if (row.fileType == '1') { // Image
                this.imageOpenTime = Date.now();
            } else if (row.fileType != '2' && row.fileType != '3') { // Video
                this.videoStartTime = Date.now();
            }
        },
        formatDuration(seconds) {
            const min = Math.floor(seconds / 60)
            const sec = seconds % 60
            return `${min}:${sec < 10 ? '0' : ''}${sec}`
        },
        async handlePreviewDialogClose() {
            if (this.currentResourceRow) {
                const row = this.currentResourceRow;
                let params = {
                    materialId: Number(row.materialId),
                };
                // 视频
                if (row.fileType == '2') {
                    if (this.$refs.videoPlayer) {
                        const video = this.$refs.videoPlayer;
                        const duration = Math.round(video.currentTime);
                        const total = Math.round(video.duration);
                        params.progress = this.formatDuration(duration);
                        params.duration = duration;
                        params.nowRate = total > 0 ? Math.round((duration / total) * 100) : 0;
                        if (row.learnRecordDTO && row.learnRecordDTO.id) {
                            params.id = row.learnRecordDTO.id;
                        }
                    }
                }
                // 图片
                else if (row.fileType == '1') {
                    const duration = Math.round((Date.now() - this.imageOpenTime) / 1000);
                    params.progress = this.formatDuration(duration);
                    params.duration = duration;
                    params.nowRate = 100;
                    if (row.learnRecordDTO && row.learnRecordDTO.id) {
                        params.id = row.learnRecordDTO.id;
                    }
                }
                // PDF
                else if (row.fileType == '3') {
                    params.progress = String(this.currentPdfPage || 1);
                    params.duration = 0;
                    params.nowRate = 100;
                    if (row.learnRecordDTO && row.learnRecordDTO.id) {
                        params.id = row.learnRecordDTO.id;
                    }
                }
                // 兜底
                else {
                    params.progress = '0:00';
                    params.duration = 0;
                    params.nowRate = 0;
                }
                await this.uploadLearnRecord(params);
            }
            this.previewDialogVisible = false;
            this.currentResourceRow = null;
            // 关闭弹窗后刷新课程资源列表
            this.fetchResourceList(1);
        },
        async uploadLearnRecord(params) {
            try {
                await addTrainLearnRecord(params)
            } catch (e) {
                this.$message.error('学习进度上报失败')
            }
        },
        isImage(url) {
            return url && (url.endsWith('.jpg') || url.endsWith('.jpeg') || url.endsWith('.png') || url.endsWith('.gif'));
        },
        isVideo(url) {
            return url && (url.endsWith('.mp4') || url.endsWith('.avi') || url.endsWith('.mov') || url.endsWith('.mkv'));
        },
        async startExam() {
            if (!this.currentExamDetail || !this.currentExamDetail.id) {
                this.$message.error('试卷信息有误');
                return;
            }
            const params = {
                majorId: this.currentExamDetail.majorId,
                bizType: this.currentExamDetail.quizType || '5',
                quizConfigId: this.currentExamDetail.id
            };
            try {
                const res = await bizTypeExamination(params);
                if (res.code === 200 && res.data && res.data.trainQuestionList) {
                    // 先清理章节练习缓存，避免干扰
                    localStorage.removeItem('trainQuestionList');
                    // 存考试数据
                    localStorage.setItem('examData', JSON.stringify(res.data));
                    this.$router.push({
                        name: 'ExamPage',
                        query: {
                            quizConfigId: this.currentExamDetail.id,
                            majorId: this.currentExamDetail.majorId,
                            level: this.currentExamDetail.level,
                            quizType: this.currentExamDetail.quizType,
                            direction: this.currentExamDetail.direction
                        }
                    });
                    this.examDrawerVisible = false;
                } else {
                    this.$message.error(res.msg || '获取试卷失败');
                }
            } catch (e) {
                this.$message.error('获取试卷失败');
            }
        },
        ensureContainsOne(str) {
            if (!str) return '1';
            const arr = String(str).split(',').map(s => s.trim()).filter(Boolean);
            if (!arr.includes('1')) arr.unshift('1');
            return Array.from(new Set(arr)).join(',');
        },
    },
    watch: {
        videoDialogVisible(val) {
            if (val) {
                this.$nextTick(() => {
                    const dialog = document.querySelector('.drawer-dialog .el-dialog')
                    if (dialog) dialog.classList.add('is-visible')
                })
            }
        },
        archiveDialogVisible(val) {
            if (val) {
                this.$nextTick(() => {
                    const dialog = document.querySelector('.drawer-dialog .el-dialog')
                    if (dialog) dialog.classList.add('is-visible')
                })
            }
        },
        videoListDialogVisible(val) {
            if (val) {
                this.$nextTick(() => {
                    const dialog = document.querySelector('.drawer-dialog .el-dialog')
                    if (dialog) dialog.classList.add('is-visible')
                })
            }
        },
        chapterTreeDialogVisible(val) {
            if (val) {
                this.$nextTick(() => {
                    const dialog = document.querySelector('.drawer-dialog .el-dialog')
                    if (dialog) dialog.classList.add('is-visible')
                })
            }
        },
        activeTab(val) {
            if (val === 'resource') {
                this.fetchResourceList(1)
            }
        }
    }
}
</script>

<style scoped>
.study-course {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

/* 隐藏右侧广告 */
.study-course .ad-container,
.study-course .advertisement,
.study-course .right-ad,
.study-course .sidebar-ad,
.site-header .ad-container,
.site-header .advertisement,
.site-header .right-ad,
.site-footer .ad-container,
.site-footer .advertisement,
.site-footer .right-ad {
    display: none !important;
}

.course-header {
    display: flex;
    gap: 40px;
    margin-bottom: 40px;
    background: #fff;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.progress-box {
    background: #fff;
    padding: 24px 30px;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
}

.progress-card {
    max-width: 600px;
}

.progress-title {
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 12px;
}

.progress-text {
    margin-top: 10px;
}

.course-cover {
    width: 400px;
    height: 300px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
}

.course-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.course-cover:hover img {
    transform: scale(1.05);
}

.course-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.course-title {
    font-size: 28px;
    color: #2c3e50;
    margin-bottom: 24px;
    line-height: 1.4;
    font-weight: 600;
}

.course-meta {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 24px;
    padding: 20px;
    background: #f8fafc;
    border-radius: 8px;
}

.meta-group {
    display: flex;
    gap: 40px;
}

.meta-item {
    display: flex;
    align-items: center;
    color: #666;
    font-size: 15px;
    min-width: 160px;
}

.meta-item i {
    margin-right: 8px;
    color: #409EFF;
    font-size: 18px;
}

.meta-label {
    color: #666;
    margin-right: 8px;
}

.meta-value {
    color: #2c3e50;
    font-weight: 500;
}

.course-desc {
    color: #666;
    line-height: 1.8;
    font-size: 15px;
    background: #f8fafc;
    padding: 20px;
    border-radius: 8px;
    flex: 1;
}

.course-content {
    background: #fff;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.catalog-list {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
}

.catalog-section {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: linear-gradient(135deg, #409EFF 0%, #2c5282 100%);
    margin-bottom: 0;
    border-bottom: none;
}

.section-title {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    position: relative;
    padding-left: 0;
}

.section-title::before {
    display: none;
}

.section-content {
    padding: 20px;
}

.catalog-item {
    display: flex;
    align-items: center;
    padding: 20px;
    margin-bottom: 15px;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s;
    background: #f8fafc;
    border: 1px solid #edf2f7;
    position: relative;
    overflow: hidden;
}

.catalog-item:last-child {
    margin-bottom: 0;
}

.catalog-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 100%;
    background: #409EFF;
    opacity: 0;
    transition: opacity 0.3s;
}

.catalog-item:hover {
    background: #fff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border-color: #409EFF;
}

.catalog-item:hover::before {
    opacity: 1;
}

.catalog-item.is-active {
    background: #ecf5ff;
    border-color: #409EFF;
    color: #409EFF;
}

.catalog-item.is-active::before {
    opacity: 1;
}

.catalog-item i {
    margin-right: 15px;
    font-size: 24px;
    color: #409EFF;
    background: rgba(64, 158, 255, 0.1);
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    transition: all 0.3s;
}

.catalog-item:hover i {
    background: #409EFF;
    color: #fff;
    transform: scale(1.1);
}

.item-title {
    flex: 1;
    font-size: 16px;
    font-weight: 500;
    color: #2c3e50;
}

.item-status {
    color: #409EFF;
    font-size: 14px;
    padding: 6px 16px;
    background: rgba(64, 158, 255, 0.1);
    border-radius: 20px;
    font-weight: 500;
    transition: all 0.3s;
}

.catalog-item:hover .item-status {
    background: #409EFF;
    color: #fff;
}

.drawer-dialog {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    margin: 0 !important;
    height: 100vh;
}

.drawer-dialog .el-dialog {
    margin: 0 !important;
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #fff;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
}

.drawer-dialog .el-dialog.is-visible {
    transform: translateX(0);
}

.drawer-dialog .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid #eee;
    margin: 0;
    background: #fff;
}

.drawer-dialog .el-dialog__body {
    flex: 1;
    overflow: hidden;
    padding: 0;
    background: #fff;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
}

.drawer-dialog .el-dialog__headerbtn {
    top: 20px;
    right: 20px;
    font-size: 20px;
}

.drawer-dialog .el-dialog__headerbtn:hover {
    color: #409EFF;
}

.drawer-dialog .video-container,
.drawer-dialog .archive-container,
.drawer-dialog .video-list-container,
.drawer-dialog .chapter-tree-container {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    overflow: auto;
    display: flex;
    flex-direction: column;
}

.video-player {
    width: 100%;
    height: 70vh;
    object-fit: contain;
    background: #000;
    display: block;
}

.drawer-dialog img,
.drawer-dialog video {
    max-width: 100%;
    height: auto;
    display: block;
}

.drawer-dialog .el-dialog {
    max-width: 100vw;
    width: 80vw !important;
    min-width: 300px;
}

.drawer-dialog .archive-container {
    padding: 20px;
}

.drawer-dialog .archive-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
}

.drawer-dialog .archive-item {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
}

.drawer-dialog .archive-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.drawer-dialog .archive-image {
    width: 100%;
    height: 200px;
    overflow: hidden;
}

.drawer-dialog .archive-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.drawer-dialog .archive-item:hover .archive-image img {
    transform: scale(1.05);
}

.drawer-dialog .archive-info {
    padding: 15px;
}

.drawer-dialog .archive-info h3 {
    margin: 0 0 10px 0;
    font-size: 16px;
    color: #2c3e50;
    line-height: 1.4;
}

.drawer-dialog .archive-meta {
    display: flex;
    gap: 15px;
    color: #666;
    font-size: 14px;
}

.drawer-dialog .archive-meta .meta-item {
    display: flex;
    align-items: center;
    gap: 5px;
}

.drawer-dialog .archive-meta .meta-item i {
    color: #409EFF;
}

.drawer-dialog .video-list-container {
    padding: 20px;
}

.drawer-dialog .video-list {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.drawer-dialog .video-section {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.drawer-dialog .section-header {
    padding: 20px;
    background: linear-gradient(135deg, #409EFF 0%, #2c5282 100%);
    margin-bottom: 0;
    border-bottom: none;
}

.drawer-dialog .section-header h3 {
    margin: 0;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
}

.drawer-dialog .section-content {
    padding: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
}

.drawer-dialog .video-item {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
}

.drawer-dialog .video-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.drawer-dialog .video-image {
    width: 100%;
    height: 200px;
    position: relative;
    overflow: hidden;
}

.drawer-dialog .video-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.drawer-dialog .video-duration {
    position: absolute;
    bottom: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 14px;
}

.drawer-dialog .video-item:hover .video-image img {
    transform: scale(1.05);
}

.drawer-dialog .video-info {
    padding: 15px;
}

.drawer-dialog .video-info h4 {
    margin: 0 0 10px 0;
    font-size: 16px;
    color: #2c3e50;
    line-height: 1.4;
}

.drawer-dialog .video-meta {
    display: flex;
    gap: 15px;
    color: #666;
    font-size: 14px;
}

.drawer-dialog .video-meta .meta-item {
    display: flex;
    align-items: center;
    gap: 5px;
}

.drawer-dialog .video-meta .meta-item i {
    color: #409EFF;
}

.drawer-dialog .chapter-tree-container {
    padding: 20px;
}

.drawer-dialog .chapter-tree {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.drawer-dialog .chapter-section {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.drawer-dialog .section-header {
    padding: 20px;
    background: linear-gradient(135deg, #409EFF 0%, #2c5282 100%);
    margin-bottom: 0;
    border-bottom: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.drawer-dialog .section-header h3 {
    margin: 0;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
}

.drawer-dialog .section-meta {
    color: #fff;
    font-size: 14px;
}

.drawer-dialog .section-content {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.drawer-dialog .chapter-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: #f8fafc;
    border-radius: 8px;
    transition: all 0.3s ease;
}

.drawer-dialog .chapter-item:hover {
    background: #ecf5ff;
    transform: translateX(5px);
}

.drawer-dialog .chapter-info {
    flex: 1;
}

.drawer-dialog .chapter-info h4 {
    margin: 0 0 10px 0;
    font-size: 16px;
    color: #2c3e50;
}

.drawer-dialog .chapter-meta {
    display: flex;
    gap: 15px;
    color: #666;
    font-size: 14px;
}

.drawer-dialog .meta-item {
    display: flex;
    align-items: center;
    gap: 5px;
}

.drawer-dialog .meta-item i {
    color: #409EFF;
}

.all-resource-scroll-list {
    max-height: 70vh;
    overflow-y: auto;
    padding: 10px 0;
}

.resource-card {
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
}

.resource-card img {
    width: 100%;
    height: 120px;
    object-fit: cover;
    border-radius: 4px;
}

.resource-card-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100px;
    padding-top: 8px;
}

.resource-card-title {
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 6px;
    color: #333;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.resource-card-meta {
    font-size: 13px;
    color: #666;
    margin-bottom: 2px;
}

.config-dialog-header {
    padding: 10px 0 10px 10px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 10px;
}

.config-course-title {
    font-size: 18px;
    font-weight: bold;
    color: #222;
    margin-bottom: 4px;
}

.config-course-range {
    font-size: 14px;
    color: #666;
}

.config-course-selected {
    font-size: 15px;
    color: #409EFF;
    margin-top: 6px;
}

.config-course-selected .over-range {
    color: #f56c6c;
    font-weight: bold;
}

.config-dialog-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 16px 10px 0 10px;
    border-top: 1px solid #f0f0f0;
    margin-top: 10px;
    gap: 20px;
}

.resource-card.is-selected {
    outline: 2px solid #409EFF;
    box-shadow: 0 0 8px #409eff33;
}

.resource-card-checkbox {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
}

.resource-card-wrapper {
    cursor: pointer;
}

.resource-card-wrapper.is-selected .resource-card {
    outline: 2px solid #409EFF;
    box-shadow: 0 0 8px #409eff33;
    background: #ecf5ff;
}

/* 隐藏可能存在的广告元素 */
.advertisement,
.ad-banner,
.right-ad,
.sidebar-ad,
.ad-container,
[data-ad],
[class*="ad-"],
[class*="-ad"] {
    display: none !important;
}

@media (max-width: 1200px) {
    .course-header {
        flex-direction: column;
        padding: 20px;
    }

    .course-cover {
        width: 100%;
        height: 400px;
    }

    .meta-group {
        flex-direction: column;
        gap: 15px;
    }

    .meta-item {
        min-width: auto;
    }

    .catalog-list {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .course-cover {
        height: 300px;
    }

    .course-title {
        font-size: 24px;
    }

    .course-meta {
        padding: 15px;
    }

    .meta-item {
        font-size: 14px;
    }

    .catalog-item {
        padding: 15px;
    }

    .catalog-item i {
        width: 40px;
        height: 40px;
        font-size: 20px;
    }

    .item-title {
        font-size: 15px;
    }

    .item-status {
        padding: 4px 12px;
        font-size: 13px;
    }
}

.drawer-content {
    padding: 24px 32px;
    height: 100%;
    overflow-y: auto;
    background: #fafbfc;
}

.preview-container {
    text-align: center;
}

.chapter-section {
    border-radius: 8px;
    background: #fff;
}

.chapter-item {
    border-radius: 6px;
    background: #f8fafc;
}

.archive-item-card {
    border-radius: 8px;
    background: #fff;
}

.video-item-card {
    border-radius: 8px;
    background: #f8fafc;
}

</style>

<style>
/* 针对StudyCourse页面隐藏右侧广告 */
body.no-side-ad-study-course .side-ad {
    display: none !important;
}
</style>
